import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { BellIcon } from "@heroicons/react/20/solid";
import clsx from "clsx";
import _ from "lodash";
import { Divider } from "../UI/divider";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/digitalPour-logo.png";
import locationLogo from "../../assets/location-logo.png";
import { useLayoutStore } from "../../context";
import { ConfirmationModal } from "../Modals";

export default function TopNav() {
  const OPEN = "OPEN";
  const DIVIDER = "DIVIDER";
  const { isSidebarOpen, setSidebarMenuOpen } = useLayoutStore();
  const [businessStatus, setBusinessStatus] = useState(OPEN);
  const [promptBusinessStatus, setPromptBusinessStatus] = useState("");
  const navigate = useNavigate();

  function openBusinessStatusModal() {
    setPromptBusinessStatus(
      `Are you sure you'd like to ${
        businessStatus === OPEN ? "CLOSE" : OPEN
      } this business?`
    );
  }

  const dropdownItems = [
    { label: "Last Call", path: "/lastCall" },
    { label: "Change Password", path: "/changePassword" },
    { label: "Contact Digital Pour", path: "/contactUs" },
    { label: "Preferences", path: "/userSettings" },
    { label: DIVIDER },
    { label: "Logout", path: "/logout" },
  ];

  return (
    <div className="flex w-screen h-16 items-center justify-between bg-[#403e41] text-white px-4 fixed top-0 z-50">
      <div className="flex flex-1">
        <div className="mr-2 lg:mr-6 flex items-center space-x-4 cursor-pointer">
          {isSidebarOpen ? (
            <svg
              width="2rem"
              height="2rem"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              onClick={() => setSidebarMenuOpen(false)}
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 5C3.44772 5 3 5.44772 3 6C3 6.55228 3.44772 7 4 7H20C20.5523 7 21 6.55228 21 6C21 5.44772 20.5523 5 20 5H4ZM4 11C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13H20C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11H4ZM13 18C13 17.4477 13.4477 17 14 17H20C20.5523 17 21 17.4477 21 18C21 18.5523 20.5523 19 20 19H14C13.4477 19 13 18.5523 13 18Z"
                fill="#da7744"
              />
            </svg>
          ) : (
            <svg
              width="2rem"
              height="2rem"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              onClick={() => setSidebarMenuOpen(true)}
            >
              <path
                d="M4 18H10"
                stroke="#da7744"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M4 12L20 12"
                stroke="#da7744"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M4 6L20 6"
                stroke="#da7744"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          )}
        </div>
        <img
          src={logo}
          alt="logo"
          className="h-12 cursor-pointer"
          onClick={() => navigate("/")}
        />
      </div>
      {promptBusinessStatus ? (
        <ConfirmationModal
          modalOpen
          title="Change Business Status"
          message={promptBusinessStatus}
          confirmButtonText="Yes"
          toggle={() => setPromptBusinessStatus("")}
          onConfirm={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setBusinessStatus(businessStatus === OPEN ? "CLOSED" : OPEN);
            setPromptBusinessStatus("");
          }}
        />
      ) : null}
      <div className="flex flex-row items-center space-x-4 pr-2">
        {/* no notices icon */}
        <BellIcon className="h-6 w-6 cursor-pointer" />
        {/* new/unread notices icon */}
        {/* <BellAlertIcon className="h-6 w-6 cursor-pointer" /> */}
        <span
          className={clsx(
            {
              "border-green-500": businessStatus === OPEN,
              "border-red-500": businessStatus !== OPEN,
            },
            "border-2 rounded-md px-2 py-1 text-sm font-semibold cursor-pointer"
          )}
          onClick={openBusinessStatusModal}
        >
          {businessStatus}
        </span>
        <span className="flex flex-col items-end">
          <p className="ml-2 text-sm">0 Test Location</p>
          <p className="ml-2 text-xs">Sightsource</p>
        </span>
        <Menu as="div" className="relative">
          <MenuButton className="flex rounded-full cursor-pointer focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-2 focus:ring-offset-[#403e41] items-center">
            <img
              src={locationLogo}
              alt="avatar"
              className="h-10 w-10 rounded-full"
            />
          </MenuButton>
          <MenuItems className="absolute right-0 z-50 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
            {_.map(dropdownItems, (item, idx) => {
              if (item.label === DIVIDER)
                return (<MenuItem key={"divider-" + idx}>
                    <Divider />
                  </MenuItem>)
              return (
                <MenuItem key={item.label} className="z-50">
                  <div
                    className={` block px-4 py-2 text-sm text-gray-700 hover:cursor-pointer`}
                    onClick={() => {
                      if (item && item.path) {
                        navigate(item.path);
                      }
                    }}
                  >
                    {item.label}
                  </div>
                </MenuItem>
              );
            })}
          </MenuItems>
        </Menu>
      </div>
    </div>
  );
}
